// @ts-nocheck
import styled from 'styled-components';

import HeroSection from './Sections/HeroSection';
import TestimonialSection from './Sections/TestimonialSection';
import CounsellorSection from './Sections/CounsellorSection';
import DiscoverSection from './Sections/DiscoverSection';
import ExploreSection from './Sections/ExploreSection';
import ServiceSection from './Sections/ServiceSection';
import OrganizationSection from './Sections/OrganizationSection';
import GridServiceSection from './Sections/GridServiceSection';
import EnterpriseSection from './Sections/EnterpriseSection';
import VideoSection from './Sections/VideoSection';
// import BlogSection from './Sections/BlogSection';
import CallToAction from './Sections/CallToAction';
import AiSection from './Sections/AiSection';
import GetStarted from './Sections/GetStarted';
import AiButton from '../../components/AiButton/AiButton';
import SkillSection from './Sections/SkillSection';
import CounterSection from './Sections/CounterSection';

interface SectionContainerProps {
  bgColor?: string;
  padding?: string;
  margin?: string;
}

interface Counsellor {
  imageUrl: string;
  name: string;
  description: string;
  profileLink?: string;
  bookingLink?: string;
}

const Home = () => {
  const allCounsellors: Counsellor[] = [
    {
      imageUrl: 'https://tackoom.com/kulshum.jpg',
      name: 'Kulshum Khan',
      description: 'Academic Counselor',
      profileLink: 'https://tackoom.com/consultant/kulshum-khan-1850',
      bookingLink: 'https://tackoom.com/consultant/kulshum-khan-1850', // Define the actual booking link
    },
    {
      imageUrl: 'https://beta.tackoom.com/hd_nicolay.jpg',
      name: 'H.D Nicolay',
      description: 'Therapien||Family Therapy Counseling|| Nicolay Coaching',
      profileLink: 'https://tackoom.com/consultant/hd-%20nicolay-2740', // Define the actual profile link
      bookingLink: 'https://tackoom.com/consultant/hd-%20nicolay-2740', // Define the actual booking link
    },
    {
      imageUrl: 'https://beta.tackoom.com/shashi.jpg',
      name: 'Shashi Bhattarai',
      description: 'Professor||Educator||Counselor',
      profileLink: 'https://tackoom.com/consultant/shashi-bhattarai-1761', // Define the actual profile link
      bookingLink: 'https://tackoom.com/consultant/shashi-bhattarai-1761', // Define the actual booking link
    },
    {
      imageUrl: 'https://beta.tackoom.com/krishna.jpg',
      name: 'Krishna Kumar Pant',
      description: 'Psychology Analyst (Psychometric Counseling)',
      profileLink: 'https://tackoom.com/consultant/%7Fkrishna-%20kumar%20pant-2206', // Define the actual profile link
      bookingLink: 'https://tackoom.com/consultant/%7Fkrishna-%20kumar%20pant-2206', // Define the actual booking link
    },
    {
      imageUrl: 'https://beta.tackoom.com/swechha.jpg',
      name: 'Swechha Sharma',
      description: 'Admissions Officer',
      profileLink: 'https://tackoom.com/consultant/swechha-%20sharma-2028', // Define the actual profile link
      bookingLink: 'https://tackoom.com/consultant/swechha-%20sharma-2028', // Define the actual booking link
    },
    {
      imageUrl: 'https://beta.tackoom.com/pratikchya.jpg',
      name: 'Pratikchya Sharma',
      description: 'Educator and Counselor',
      profileLink: 'https://tackoom.com/consultant/swechha-%20sharma-2028', // Define the actual profile link
      bookingLink: 'https://tackoom.com/consultant/swechha-%20sharma-2028', // Define the actual booking link
    },
    {
      imageUrl: 'https://beta.tackoom.com/barshana.jpg',
      name: 'Barshana Thapaliya',
      description: 'Social Work Professor',
      profileLink: 'https://tackoom.com/consultant/barshana-thapaliya-2384', // Define the actual profile link
      bookingLink: 'https://tackoom.com/consultant/barshana-thapaliya-2384', // Define the actual booking link
    },
    {
      imageUrl: 'https://beta.tackoom.com/profile.jpg',
      name: 'Chiranjivi Basnet',
      description: 'Scholarships and Guidance',
      profileLink: 'https://tackoom.com/consultant/Chiranjivi-Basnet-2562', // Define the actual profile link
      bookingLink: 'https://tackoom.com/consultant/Chiranjivi-Basnet-2562', // Define the actual booking link
    },
    {
      imageUrl: 'https://beta.tackoom.com/profile.jpg',
      name: 'Sonam Dangol',
      description: 'Mental Health Counselor',
      profileLink: 'https://tackoom.com/consultant/Sonam-Dangol-2651', // Define the actual profile link
      bookingLink: 'https://tackoom.com/consultant/Sonam-Dangol-2651', // Define the actual booking link
    },
    {
      imageUrl: 'https://beta.tackoom.com/nisha.jpg',
      name: 'Nisha Karki',
      description: 'PsychoSocial Counselor',
      profileLink: 'https://tackoom.com/consultant/nisha-%20karki-2473', // Define the actual profile link
      bookingLink: 'https://tackoom.com/consultant/nisha-%20karki-2473', // Define the actual booking link
    },
  ];

  const midIndex = Math.ceil(allCounsellors.length / 2);
  const premiumPicks = allCounsellors.slice(0, midIndex);
  const expertPicks = allCounsellors.slice(midIndex);

  return (
    <main>
      {/* hero-section */}
      <HeroSection />

      {/* get started */}
      <SectionContainer bgColor="#ffffff" padding="25px 0px">
        <GetStarted />
      </SectionContainer>

      {/* ai section */}
      <AiSection />

      {/* top counsellor section */}
      <SectionContainer
        id="get-counselors"
        bgColor="#ffffff"
        padding="20px 0px"
      >
        <CounsellorSection
          title="Premium Picks"
          imgProps="circular"
          type="ctoCard"
          counsellors={premiumPicks}
        />
      </SectionContainer>

      {/* Recommended counsellor section */}
      <SectionContainer bgColor="#ffffff" padding="20px 0px">
        <CounsellorSection
          title="Expert Picks"
          imgProps="full"
          type="profile"
          counsellors={expertPicks}
        />
      </SectionContainer>

      {/* grid service section */}
      {/* <section id="gigs-section">
        <GridServiceSection />
      </section> */}

      {/* Category Skill Section */}
      <SectionContainer
        id="category-section"
        bgColor="#ffffff"
        padding="25px 0px"
      >
        <SkillSection />
      </SectionContainer>

      {/* Services section */}
      <SectionContainer bgColor="#ffffff" padding="20px 0px">
        <ServiceSection title="Services" />
      </SectionContainer>

      {/* enterprise carousel */}
      <SectionContainer bgColor="#ffffff" padding="20px 0px">
        <EnterpriseSection
          title="Check 800+ Organizations"
          imgProps="full"
          type="profile"
        />
      </SectionContainer>

      {/*Organization Section */}
      <SectionContainer bgColor="#ffffff" padding="25px 0px">
        <OrganizationSection />
      </SectionContainer>

      {/* testimonial section */}
      <SectionContainer bgColor="#f5e7e0" padding="0px  0px 40px 0px">
        <Section>
          <SecondaryHeading className="manrope-extrabold">
            <center>The wall of love</center>
          </SecondaryHeading>
          <TestimonialSection />
        </Section>
      </SectionContainer>

      {/* Discover Section */}
      <SectionContainer bgColor="#ffffff" padding="25px 0px">
        <DiscoverSection />
      </SectionContainer>

      {/* ExploreSection */}
      <SectionContainer bgColor="#ffffff" padding="25px 0px">
        <ExploreSection />
      </SectionContainer>

      {/* Video Section */}
      <SectionContainer bgColor="#ffffff" padding="25px 0px">
        <VideoSection />
      </SectionContainer>

      {/* <BlogSection /> */}


      <CounterSection />

      {/* CallToAction */}
      <SectionContainer bgColor="#ffffff" padding="20px 0px">
        <CallToAction />
      </SectionContainer>

      <AiButton />
    </main>
  );
};

export default Home;

// global
const SecondaryHeading = styled.h2`
  font-size: 2.15rem;
  margin: 1.5rem 0rem;
`;

const SectionContainer = styled.div<SectionContainerProps>`
  background: ${(props) => props.bgColor || '#ffffff'};
  padding: ${(props) => props.padding || '0px'};
  margin: ${(props) => props.margin || '0px'};
  overflow: hidden;
`;

const Section = styled.section`
  width: 1150px;
  margin-left: 50%;
  transform: translateX(-50%);
`;